import { motion } from 'framer-motion';
import { TiltCard } from '../ui/TiltCard';

export function Contact() {
    return (
        <section id="contact" className="py-32 px-6 md:px-12 bg-black/40">
            <div className="max-w-4xl mx-auto text-center perspective-1000">
                <TiltCard className="p-12 md:p-20 bg-emerald-500/5 border border-emerald-500/20 backdrop-blur-xl rounded-3xl">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <span className="text-emerald-500 font-mono text-sm tracking-widest mb-4 block">
                            // 03. CONTACT
                        </span>
                        <h2 className="text-5xl md:text-7xl font-black mb-8 text-white tracking-tight">
                            Let's Build <br /> The Future.
                        </h2>
                        <p className="text-gray-400 text-xl max-w-2xl mx-auto mb-12">
                            Have an idea that defies gravity? I'm always open to discussing new projects,
                            creative ideas or opportunities to be part of your visions.
                        </p>

                        <a
                            href="mailto:hello@paraslehana.in"
                            className="inline-block px-12 py-4 text-lg font-bold text-black bg-emerald-500 rounded-full hover:bg-emerald-400 hover:scale-105 transition-all duration-300 shadow-[0_0_20px_rgba(16,185,129,0.5)] relative z-20"
                        >
                            Say Hello
                        </a>
                    </motion.div>
                </TiltCard>
            </div>
        </section>
    );
}
